export default {
  "title": "News",
  "subtitle": "Announcements and release notes from QuickBox",
  "announcements": "Announcements",
  "announcementCount_one": "{{count}} announcement",
  "announcementCount_other": "{{count}} announcements",
  "newsReleases": "News and releases",
  "none": "No announcements found",
  "availableLater": "News announcements will appear here when available",
  "searchPlaceholder": "Search announcements...",
  "searchLabel": "Search announcements",
  "filterType": "Filter by type",
  "channel": "{{channel}} Channel",
  "noMatches": "No matches",
  "release": "Release",
  "releases": "Releases",
  "all": "All",
  "stable": "Stable",
  "beta": "Beta",
  "dev": "Dev",
  "select": "Select an announcement to view",
  "choose": "Choose an entry from the list on the left",
  "loadFailed": "Failed to load announcement content.",
  "copyLink": "Copy link",
  "versionTitle": "Version Update",
  "newsTitle": "QuickBox News"
} as const;
